import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';

import Btn from '../../components/Btn';
import ClientInfo from './ClientInfo';
import Contact from './Contact';
import './addClient.css';


class AddClient extends Component {
    static propTypes = {
        isLocked: PropTypes.bool.isRequired,
        firstName: PropTypes.string.isRequired,
        authToken: PropTypes.string.isRequired,
        phone: PropTypes.string.isRequired,
        position: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        companyName: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        street2: PropTypes.string.isRequired,
        Zip: PropTypes.string.isRequired,
        clientUpdateStatus: PropTypes.string.isRequired,
        selectedState: PropTypes.number.isRequired,
        setCreateIsVisible: PropTypes.func.isRequired,
        isVisible: PropTypes.bool.isRequired,
        createClient: PropTypes.func.isRequired,
    };

  handleChange = (e) => {
      this.setState({
          [e.target.id]: e.target.value,
      });
  }
  saveHandler= () => {
      const {
          selectedState,
          companyName,
          street,
          street2,
          Zip,
          firstName,
          lastName,
          phone,
          position,
          email,
          city,
          authToken,
          country,
      } = this.props;
      const client = {
          inputs: {
              companyName,
              firstName,
              lastName,
              email,
              phone,
              position,
              address_attributes: {
                  street,
                  street2,
                  selectedState,
                  country,
                  city,
                  Zip,
              },
          },
      };
      this.props.createClient(client, authToken);
  }

  toggleCreateVisiblity() {
      const { setCreateIsVisible, isVisible } = this.props;
      setCreateIsVisible(!isVisible);
  }

  render() {
      const { isLocked, authToken, clientUpdateStatus } = this.props;
      if (!authToken) return <Redirect to="/" />;
      return (
          <div>
              <div className="createClientStatus">{clientUpdateStatus || null}</div>
              <div className="contactContainer">
                  <div className="row">
                      <div className="col span-1-of-2">
                          <ClientInfo />
                      </div>
                      <div className="col span-1-of-2">
                          <Contact />
                      </div>
                  </div>
              </div>
              <Btn
                  variant="contained"
                  label="Add Add Customer"
                  disabled={isLocked}
                  onClick={this.saveHandler}
                  className="greenHover"
              />

          </div>
      );
  }
}


export default (AddClient);



// WEBPACK FOOTER //
// ./src/containers/AddClient/AddClient.js